import { render, staticRenderFns } from "./RewardsList.vue?vue&type=template&id=48194b96&"
import script from "./RewardsList.vue?vue&type=script&lang=ts&"
export * from "./RewardsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports